module.exports = __webpack_public_path__ + "static/media/profile-pic@2x.38191c81.jpg";